module.exports = __webpack_public_path__ + "static/media/FMB_icon1.a97bdd2a.svg";